import React from "react";
import { useSelector } from "react-redux";
import Loading from "../../../Loading";
import RelatedPostItem from "./Item";

const RelatedPosts = () => {
    const { relatedBlogs, isLoading } = useSelector(
        (state) => state.relatedBlogs
    );

    if (isLoading) {
        return <Loading />;
    }

    if (relatedBlogs.length === 0) {
        return <h1 className="text-xl">No Related post Found!</h1>;
    }

    return (
        <aside>
            <h4 className="mb-4 text-xl font-medium" id="lws-relatedPosts">
                Related Posts
            </h4>
            <div className="space-y-4 related-post-container">
                {relatedBlogs?.map((blog) => (
                    <RelatedPostItem key={blog.id} blog={blog} />
                ))}
            </div>
        </aside>
    );
};

export default RelatedPosts;
